import React from 'react';
import './endcap.scss';
import { TopBarPropType, TopBarDefaultPropType } from './Helper';

const TopBar = ({ gradientColors }) => {

  if (!(Array.isArray(gradientColors) && gradientColors?.length)) return null;
  const GRADIENT_DIRECTION = '60deg';

  return (
    <>
      { gradientColors?.length > 1 && (
        <div
          className="topBar"
          style={{ background: `linear-gradient(${GRADIENT_DIRECTION}, ${gradientColors.join(',')})` }}
        />
      ) }
      { gradientColors?.length === 1 && (
        <div
          className="topBar"
          style={{ background: `${gradientColors[0]}` }}
        />
      )}
    </>
  );
};

TopBar.propTypes = TopBarPropType;
TopBar.defaultProps = TopBarDefaultPropType;

export { TopBar };
